// Libs
import classNames from 'classnames/bind';
import { useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box, Stack } from '@mui/material';
// Components, Layouts, Pages
// Others
import { IFormService } from '~/utils/interface/service';
import { DEFAULT_NUMBER_ZERO } from '~/utils/constants/common';
import { formatDecimal } from '~/utils/helper/common';
// Styles, images, icons
import styles from './TotalService.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const MaterialService = (props: Props) => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/service']);

  const { control, setValue } = useFormContext<IFormService>();
  const watchMaterials = useWatch({ control, name: 'materials' });
  const watchLabor = useWatch({ control, name: 'labors' });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  const totalCost = useMemo(() => {
    const materialCost = (watchMaterials ?? [])?.reduce((total, material) => {
      return total + (Number(material?.totalCost) || DEFAULT_NUMBER_ZERO);
    }, DEFAULT_NUMBER_ZERO);

    const laborCost = (watchLabor ?? [])?.reduce((total, labor) => {
      return total + (Number(labor?.hourlyCost) || DEFAULT_NUMBER_ZERO);
    }, DEFAULT_NUMBER_ZERO);

    return materialCost + laborCost;
  }, [watchMaterials, watchLabor]);

  const totalPrice = useMemo(() => {
    const materialPrice = (watchMaterials ?? [])?.reduce((total, material) => {
      return total + (Number(material?.totalPrice) || DEFAULT_NUMBER_ZERO);
    }, DEFAULT_NUMBER_ZERO);

    const laborPrice = (watchLabor ?? [])?.reduce((total, labor) => {
      return total + (Number(labor?.hourlyPrice) || DEFAULT_NUMBER_ZERO);
    }, DEFAULT_NUMBER_ZERO);

    return materialPrice + laborPrice;
  }, [watchMaterials, watchLabor]);
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    setValue('totalCost', totalCost);
    setValue('totalPrice', totalPrice);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCost, totalPrice]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='totalServiceComponent'>
      <Stack direction='row' justifyContent={'end'} spacing={'5px'}>
        <Box className={cx('textTotal')}>{t('form_service_label_total_cost')}</Box>
        <Box className={cx('textTotal')}>{`$${formatDecimal(Number(totalCost) || DEFAULT_NUMBER_ZERO)}`}</Box>
      </Stack>

      <Stack direction='row' justifyContent={'end'} spacing={'5px'}>
        <Box className={cx('textTotal')}>{t('form_service_label_total_price')}</Box>
        <Box className={cx('textTotal')}>{`$${formatDecimal(
          Number(totalPrice) || DEFAULT_NUMBER_ZERO
        )}`}</Box>
      </Stack>
    </Box>
  );
};

export default MaterialService;
